import React from 'react';
import { ReferenceArrayField, TextField } from 'react-admin';
import { List } from '../../../../../components/List';
import StyledDatagrid from '../../../../../components/StyledDatagrid';
import { CustomPagination } from '../../../../../components/CustomPagination';
import NoItemsPage from '../../../../../components/NoItemsPage';
import ListHeader from './ListHeader';
import ItemActions from './ItemActions';
import LanguageChip from './LanguageChips';
import LastUpdatedField from './LastUpdatedField';

const ConsentItemsList = props => {
  const parsedId = props.id.replace('/universal_consent_solutions/', '');
  const createUrl = `/universal_consent_items/create?solutionID=${props.id}`;
  return (
    <List
      {...props}
      actions={null}
      resource="universal_consent_items"
      basePath="/universal_consent_items"
      filters={<ListHeader createUrl={createUrl}/>}
      empty={<NoItemsPage
        buttonText="ADD CONSENT ITEM"
        href={`#${createUrl}`}
        title="No consent items yet"
        subtitle="You can add consent items to start building out your Mobile Consent Solution."
      />}
      filter={{ universalConsentSolution: parsedId }}
      bulkActionButtons={false}
      sort={{ field: 'name', order: 'DESC' }}
      pagination={<CustomPagination/>}
    >
      <StyledDatagrid>
        <TextField source="name" sortable={false}/>
        <ReferenceArrayField label="Languages" reference="universal_consent_item_translations" source="universalConsentItemTranslations"
          sortable={false}>
          <LanguageChip/>
        </ReferenceArrayField>
        <LastUpdatedField label="Last update"/>
        <ItemActions solutionID={props.id}/>
      </StyledDatagrid>
    </List>
  );
};

export default ConsentItemsList;
